module.exports = __webpack_public_path__ + "img/pagina-nao-encontrada.b0bba77c.svg";